import { TableHeader } from '../../../components/table';

function CourseTableHeader({ actionsWidth = '300px' }) {
    return (
        <TableHeader>
            <tr>
                <th style={{ backgroundColor: '#f8f9fa', fontWeight: '500', width: '60px' }}>SL No.</th>
                <th style={{ backgroundColor: '#f8f9fa', fontWeight: '500', width: '280px' }}>Course Name</th>
                <th style={{ backgroundColor: '#f8f9fa', fontWeight: '500', width: '60px' }}>Price</th>
                <th style={{ backgroundColor: '#f8f9fa', fontWeight: '500', width: '115px' }}>Category</th>
                <th style={{ backgroundColor: '#f8f9fa', fontWeight: '500', width: '120px' }}>Status</th>
                <th style={{ backgroundColor: '#f8f9fa', fontWeight: '500', width: '155px' }}>Visibility</th>
                <th style={{ backgroundColor: '#f8f9fa', fontWeight: '500', width: actionsWidth }}>Actions</th>
            </tr>
        </TableHeader>
    );
}

export default CourseTableHeader;
